import { Observable } from "rxjs";
import HttpClient from "@/api/HttpClient";
import { APIHosts, ApiReduxHelpers } from "@/services/reduxHelpers";

export interface ExtractionRequest {
  workflowId?: string;
  mongoUri?: string;
  databaseName?: string;
  fileId: string;
  outputCollection?: string;
  s3Key: string;
  revitFilePath: string;
  project: string;
  facility?: string;
  createdAt?: string; // ISO
  metadata?: Record<string, string>;
  selectedSheetIds?: string[];
}

export interface WorkflowInfo {
  id: string;
  workflowId: string;
  fileId: string;
  project: string;
  revitFilePath: string;
  extractionType: string;
  createdAt: string;
}

export interface GetWorkflowByFileIdRequest {
  projectName: string;
  fileId: number;
}

export type GetWorkflowByFileIdResponse = WorkflowInfo[];

export interface ExtractionResponse {
  success: boolean;
  message: string;
  workflowId?: string;
}
export interface GetLogsByWorkflowRequest {
  workflowIds: string[];
}
export interface WorkflowLog {
  _id: { $oid: string };
  Timestamp: string;
  Status: string;
  WorkflowId: string;
  Stage: string;
  DurationSeconds: number | null;
  StressTest: string | null;
  Exchange: string;
  RoutingKey: string;
  Message: string;
  project: string;
}

export interface GetLogsByWorkflowResponse {
  project: string;
  totalCount: number;
  groupedLogs: Record<string, WorkflowLog[]>;
}

class ExtractionApi extends ApiReduxHelpers {
  constructor() {
    super();
  }

  ApiHost = APIHosts.App;

  public Post = {
    extractMetadata: (payload: ExtractionRequest) =>
      HttpClient.post<ExtractionResponse>(
        `${this.getHost(this.ApiHost)}/api/Extraction/extract-metadata`,
        payload
      ),
    extractGeometry: (payload: ExtractionRequest) =>
      HttpClient.post<ExtractionResponse>(
        `${this.getHost(this.ApiHost)}/api/Extraction/extract-geometry`,
        payload
      ),
    extractSheets: (payload: ExtractionRequest) =>
      HttpClient.post<ExtractionResponse>(
        `${this.getHost(this.ApiHost)}/api/Extraction/extract-sheets`,
        payload
      ),
    logsByWorkflow: (payload: GetLogsByWorkflowRequest) =>
      HttpClient.post<GetLogsByWorkflowResponse>(
        `${this.getHost(this.ApiHost)}/api/WorkflowLogs/workflow`,
        payload
      ),
  };
  public Get = {
    getWorkflowByFileId: (payload: GetWorkflowByFileIdRequest) =>
      HttpClient.get<GetWorkflowByFileIdResponse>(
        `${this.getHost(this.ApiHost)}/api/Workflow/getworkflowid?project=${
          payload.projectName
        }&fileId=${payload.fileId}`
      ).toPromise(),
  };
}

export const ExtractApi = new ExtractionApi();
export default ExtractApi;
